var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 13.2256C3.66699 11.34 3.66699 10.3972 4.25278 9.81137C4.83857 9.22559 5.78137 9.22559 7.66699 9.22559H14.3337C16.2193 9.22559 17.1621 9.22559 17.7479 9.81137C18.3337 10.3972 18.3337 11.34 18.3337 13.2256V14.2256C18.3337 17.054 18.3337 18.4682 17.455 19.3469C16.5763 20.2256 15.1621 20.2256 12.3337 20.2256H9.667C6.83857 20.2256 5.42435 20.2256 4.54567 19.3469C3.66699 18.4682 3.66699 17.054 3.66699 14.2256V13.2256Z",
    stroke: "#103680",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 8.30892V7.39225C14.6673 5.36721 13.0257 3.72559 11.0007 3.72559V3.72559C8.97561 3.72559 7.33398 5.36721 7.33398 7.39225V8.30892",
    stroke: "#103680",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0003,
    cy: 14.7254,
    r: 1.83333,
    fill: "#103680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a54371f7cba47f5e91405936a74258d9.svg";
export { ForwardRef as ReactComponent };